export default {
    auditTab: {
        actionCreated: 'Created',
        actionAmended: 'Amended',
        actionStatus: 'Status',
        secondsAgo: '{n}s ago',
        minutesAgo: '{n}m ago',
        hoursAgo: '{n}h ago',
        daysAgo: '{n}d ago',
        loadingHistory: 'Loading audit history…',
        loadFailed: 'Failed to load audit history.',
        empty: 'No audit history yet for this contract.',
        headerWhen: 'When',
        headerAction: 'Action',
        headerStatusChange: 'Status change',
        headerActor: 'Actor',
        headerDetails: 'Details',
        showDiff: 'Show diff',
        hideDiff: 'Hide diff',
        before: 'Before',
        after: 'After',
    },
}
